const ScrollUpButton = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.320312 7L7 0.320312L13.6797 7L12.4688 8.17188L7.82031 3.52344V13.6797H6.17969V3.52344L1.49219 8.17188L0.320312 7Z"
        fill="white"
      />
    </svg>
  );
};

export default ScrollUpButton;
